if (!customElements.get('wholesale-form')) {
  class WholesaleForm extends HTMLElement {
    constructor() {
      super();
    }

    handleChange(event) {
      if (!event.target.hasAttribute('name') || !event.target.getAttribute('name').includes('Name'))
        return;

      const first = this.form.querySelector('[name="contact[FirstName"]')?.value.trim() || '';
      const last = this.form.querySelector('[name="contact[LastName"]')?.value.trim() || '';

      this.nameInput.value = `${first} ${last}`.trim();
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.nameInput = this.querySelector('[name="contact[Name]"]');
      if (!this.nameInput) return;

      this.form.addEventListener('input', this.handleChange.bind(this));
    }
  }

  customElements.define('wholesale-form', WholesaleForm);
}
